












































import { Component, Vue } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';
import { CampaignListModule } from '@/store/modules/campaignList';
import { AgencyModule } from '@/store/modules/agency';
import Alert from '@/components/Shared/Alert.vue'
import CampaignDto from '@/models/Campaigns/CampaignDto'
import PageNames from '@/router/PageNames';
import GiganautVue from '@/components/Shared/GiganautVue';
import CampaignCreate from '@/components/Campaigns/CampaignCreate.vue';
import CampaignStatus from '@/components/Campaigns/Display/CampaignStatus.vue';
import CampaignListSearchCriteria from '@/components/Campaigns/CampaignListSearchCriteria.vue';


@Component({
	name: 'AgencyCampaigns',
  	components: { Alert, CampaignCreate, CampaignStatus, CampaignListSearchCriteria }
})
export default class extends GiganautVue {

  async beforeMount() {
    await CampaignListModule.searchCampaigns();
  }

  async navigateToCampaign(campaignId: string) {
    this.$router.push({ name: PageNames.AgencyCampaignDetails, params: { campaignid: campaignId } });
  }

  get loading() {
		return CampaignListModule.loading;
   }
   
  private search = '';

  get campaigns() {
    return CampaignListModule.campaigns;
  }

   private headers = [
    { text: 'Name', value: 'name' },
    { text: 'Audience Type'},
    { text: 'Owner', value: 'owner.person.firstName' },
    { text: 'Template Name', value: 'emailTemplate.name' },
    { text: 'Branch', value: 'branch.brandName' },
    { text: 'Status', value: 'status'},
    { text: 'Actions' },
  ]
}
